
import Vue from 'vue';
var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c(
    'div',
    [
      _c(
        'b-container',
        { staticClass: 'landing-container text-white', attrs: { fluid: '' } },
        [
          _c(
            'b-container',
            {
              staticClass:
                'hero-section position-relative d-flex flex-column justify-content-center align-items-center text-center py-5',
              staticStyle: { 'min-height': '100vh' },
              attrs: { fluid: '' },
            },
            [
              _c('img', {
                staticClass: 'hero-image w-100 h-100',
                attrs: {
                  loading: 'lazy',
                  src: '/assets/img/landing/showup_img_hero.webp',
                  alt: '',
                },
              }),
              _c('div', { staticClass: 'hero-background' }),
              _c('div', { staticClass: 'hero-gradient' }),
              _c(
                'div',
                {
                  staticClass:
                    'hero-content position-relative d-flex flex-column align-items-center',
                },
                [
                  _c('img', {
                    staticClass: 'company-logo mb-5',
                    staticStyle: { 'padding-bottom': '30%' },
                    attrs: {
                      loading: 'lazy',
                      src: '/assets/img/logo.svg',
                      alt: 'Show Up Productions Logo',
                    },
                  }),
                  _c('div', { staticClass: 'hero-text mt-5' }, [
                    _c('h1', { staticClass: 'hero-title display-4 fw-bold' }, [
                      _vm._v(' Transform Your Entertainment with Show Up Productions '),
                    ]),
                    _c(
                      'p',
                      {
                        staticClass: 'hero-subtitle fs-5 mt-3 mx-auto',
                        staticStyle: { 'padding-bottom': '15%' },
                      },
                      [
                        _vm._v(
                          ' Attract new guests, retain your existing ones, enhance your reputation, and drive higher yearly revenue! ',
                        ),
                      ],
                    ),
                  ]),
                ],
              ),
            ],
          ),
          _c(
            'b-container',
            { staticClass: 'main-content', attrs: { fluid: '' } },
            [
              _c(
                'b-row',
                { staticClass: 'cta-video-box' },
                [
                  _c('vimeo-player', {
                    ref: 'player2',
                    staticClass: 'video-player',
                    attrs: {
                      'video-id': '1046480802',
                      options: {
                        title: false,
                        muted: false,
                        loop: true,
                        controls: true,
                        autoplay: true,
                        responsive: true,
                      },
                    },
                  }),
                ],
                1,
              ),
              _c(
                'section',
                {
                  staticClass:
                    'cta-section text-center mb-5 d-flex justify-content-center flex-column',
                },
                [
                  _c(
                    'b-row',
                    { staticClass: 'd-flex justify-content-center' },
                    [
                      _c(
                        'b-col',
                        { attrs: { md: '3', cols: '12' } },
                        [
                          _c(
                            'b-button',
                            {
                              staticClass: 'cta-button fw-medium px-4 my-5',
                              attrs: { variant: 'light' },
                              on: { click: _vm.goToForm },
                            },
                            [_vm._v(' Book A Free Call Today! ')],
                          ),
                        ],
                        1,
                      ),
                    ],
                    1,
                  ),
                  _c(
                    'b-row',
                    { staticClass: 'd-flex justify-content-center' },
                    [
                      _c('b-col', { attrs: { md: '9', cols: '12' } }, [
                        _c('div', { staticClass: 'intro-text-wrapper mx-auto' }, [
                          _c(
                            'p',
                            {
                              staticClass: 'intro-text fs-4 text-justify',
                              staticStyle: { 'padding-top': '10%' },
                            },
                            [
                              _vm._v(
                                " In today's fast-paced world, capturing attention is more challenging than ever. This trend holds especially true in the realm of hospitality. ",
                              ),
                              _c('br'),
                              _c('br'),
                              _vm._v(' During their holidays, people crave '),
                              _c('span', { staticClass: 'fw-bold' }, [
                                _vm._v('fun, engaging, and unforgettable experiences'),
                              ]),
                              _vm._v(
                                ' — the kind they eagerly share with friends and flaunt on social media. ',
                              ),
                              _c('br'),
                              _c('br'),
                              _vm._v(
                                "If your entertainment offerings don't leave them awestruck, you risk falling short… ",
                              ),
                            ],
                          ),
                        ]),
                      ]),
                    ],
                    1,
                  ),
                ],
                1,
              ),
              _c(
                'section',
                [
                  _c(
                    'b-row',
                    [
                      _c('b-col', { attrs: { md: '6', cols: '12' } }, [
                        _c(
                          'h1',
                          {
                            staticClass: 'section-title display-5',
                            staticStyle: { 'padding-top': '10%' },
                          },
                          [_vm._v(' This is What Happens When People Book Their Holidays Now… ')],
                        ),
                      ]),
                    ],
                    1,
                  ),
                  _c(
                    'b-row',
                    { ref: 'titleSectionCard' },
                    [
                      _c('b-col', { attrs: { md: '3', cols: '12' } }, [
                        _c('p', { staticClass: 'section-subtitle fs-4 mt-2 mr-4' }, [
                          _vm._v(
                            ' Entertainment plays a crucial role in their decision-making process… ',
                          ),
                        ]),
                      ]),
                    ],
                    1,
                  ),
                ],
                1,
              ),
              _c(
                'b-row',
                { ref: 'card1Container', staticClass: 'justify-content-end pb-5 pb-md-0' },
                [
                  _c('b-col', { attrs: { md: '4', cols: '12' } }, [
                    _c('div', { staticClass: 'service-card h-100' }, [
                      _c('img', {
                        staticClass: 'service-image img-fluid mt-3',
                        attrs: {
                          loading: 'lazy',
                          src: 'https://cdn.builder.io/api/v1/image/assets/TEMP/3e7be2b0c29ccb2ceb2e0224b3e3a75b98b57147f7c986748edb8a13bf7cbdae?placeholderIfAbsent=true&apiKey=4470706791e7431fbb6c8cda4bdffef0',
                          alt: 'Hotels and Resorts Entertainment Services',
                        },
                      }),
                      _c('div', { staticClass: 'service-content pt-3 px-3' }, [
                        _c('h2', { staticClass: 'service-title fs-2 fw-bold mb-3' }, [
                          _vm._v('Cruises'),
                        ]),
                        _c(
                          'p',
                          {
                            ref: 'card1',
                            staticClass: 'service-description fs-5',
                            staticStyle: { 'margin-bottom': '0' },
                          },
                          [
                            _vm._v(
                              ' Travelers look for a mix of relaxation and excitement. They seek cruises offering both serene experiences and thrilling nightly shows. The promise of spectacular entertainment on the high seas is often the deciding factor for choosing a particular cruise. ',
                            ),
                          ],
                        ),
                      ]),
                    ]),
                  ]),
                ],
                1,
              ),
              _c(
                'b-row',
                { ref: 'card2Container', staticClass: 'justify-content-end pb-5 pb-md-0' },
                [
                  _c('b-col', { attrs: { md: '4', cols: '12' } }, [
                    _c('div', { staticClass: 'service-card h-100' }, [
                      _c('img', {
                        staticClass: 'service-image img-fluid',
                        attrs: {
                          loading: 'lazy',
                          src: 'https://cdn.builder.io/api/v1/image/assets/TEMP/424156ece3252c575c72941ea0d28134a1b44611895ed02c7e931c04b9574d91?placeholderIfAbsent=true&apiKey=4470706791e7431fbb6c8cda4bdffef0',
                          alt: 'Cruise Entertainment Services',
                        },
                      }),
                      _c('div', { staticClass: 'service-content pt-3 px-3' }, [
                        _c('h2', { staticClass: 'service-title fs-2 fw-bold mb-3' }, [
                          _vm._v('Hotels and Resorts'),
                        ]),
                        _c(
                          'p',
                          {
                            ref: 'card2',
                            staticClass: 'service-description fs-5',
                            staticStyle: { 'margin-bottom': '0' },
                          },
                          [
                            _vm._v(
                              ' Potential guests extensively browse online for videos and pictures. They look beyond the aesthetic appeal of rooms and lobbies to the vibrancy of the entertainment options. If the holiday experience appears boring and static, they quickly opt for more engaging alternatives, prioritizing places with dynamic activities and shows. ',
                            ),
                          ],
                        ),
                      ]),
                    ]),
                  ]),
                  _vm.display !== 'xs' ? _c('b-col', { attrs: { md: '4', cols: '12' } }) : _vm._e(),
                ],
                1,
              ),
              _c(
                'b-row',
                { ref: 'card3Container', staticClass: 'justify-content-end pb-3 pb-md-0' },
                [
                  _c('b-col', { attrs: { md: '4', cols: '12' } }, [
                    _c('div', { staticClass: 'service-card h-100' }, [
                      _c('img', {
                        staticClass: 'service-image img-fluid',
                        attrs: {
                          loading: 'lazy',
                          src: 'https://cdn.builder.io/api/v1/image/assets/TEMP/17bb08b914366b641820f4a32e4f0eb3607c16371b24e35d0c1fb0e8c45a66b8?placeholderIfAbsent=true&apiKey=4470706791e7431fbb6c8cda4bdffef0',
                          alt: 'Theme Park Entertainment Services',
                        },
                      }),
                      _c('div', { staticClass: 'service-content pt-3 px-3' }, [
                        _c('h2', { staticClass: 'service-title fs-2 fw-bold mb-3' }, [
                          _vm._v('Theme Parks'),
                        ]),
                        _c(
                          'p',
                          {
                            staticClass: 'service-description fs-5',
                            staticStyle: { 'margin-bottom': '0' },
                          },
                          [
                            _vm._v(
                              ' Visitors choose parks based on the quality of attractions and live entertainment. If the shows are of poor quality or repetitive, the park risks losing repeat visitors and deterring new guests. ',
                            ),
                            _c('br'),
                            _c('br'),
                            _vm._v(
                              " High-quality, diverse entertainment is essential to maintaining a park's appeal and ensuring visitors return year after year. ",
                            ),
                          ],
                        ),
                      ]),
                    ]),
                  ]),
                ],
                1,
              ),
              _c('hr', { staticClass: 'section-divider mx-auto my-5' }),
              _c(
                'section',
                { staticClass: 'challenges-section my-5 pt-5' },
                [
                  _c(
                    'b-row',
                    { staticClass: 'd-flex justify-content-center' },
                    [
                      _c('b-col', { attrs: { md: '10', cols: '12' } }, [
                        _c('h2', { staticClass: 'section-title display-5 text-center' }, [
                          _vm._v(
                            " What if You're Not Offering Great Entertainment or, Worse, Don't Have Entertainment At All? ",
                          ),
                        ]),
                      ]),
                    ],
                    1,
                  ),
                  _c(
                    'b-row',
                    { staticClass: 'd-flex justify-content-center' },
                    [
                      _c('b-col', { attrs: { md: '6', cols: '12' } }, [
                        _c('p', { staticClass: 'section-subtitle fs-4 mt-4 text-center' }, [
                          _vm._v(
                            ' In The Competitive World of Travel And Hospitality, Failing to Offer Great Entertainment Can Lead to a Host of Negative Outcomes For Your Business… ',
                          ),
                        ]),
                      ]),
                    ],
                    1,
                  ),
                  _c('div', { staticClass: 'challenges-grid my-5 p-2' }, [
                    _c('div', { staticClass: 'row' }, [
                      _c('div', { staticClass: 'col-12 col-md-4 mb-4' }, [
                        _c(
                          'div',
                          {
                            staticClass:
                              'challenge-card d-flex flex-column align-items-start text-left pb-5 pb-md-0',
                          },
                          [
                            _c('div', { staticClass: 'row' }, [
                              _c('div', { staticClass: 'col-8 d-flex align-items-center' }, [
                                _c('img', {
                                  staticClass: 'challenge-icon mb-2',
                                  attrs: {
                                    loading: 'lazy',
                                    src: 'https://cdn.builder.io/api/v1/image/assets/TEMP/5e37e33bfe3d8bfc9a9c00cba8c5d71c141011196162fdce7966cdc9b82c3c1b?placeholderIfAbsent=true&apiKey=4470706791e7431fbb6c8cda4bdffef0',
                                    alt: 'Reputation Icon',
                                  },
                                }),
                              ]),
                              _c('div', { staticClass: 'col-12 col-md-7' }, [
                                _c(
                                  'h3',
                                  { staticClass: 'challenge-title mb-2 font-weight-normal' },
                                  [_vm._v(' Damaged Reputation and Awareness ')],
                                ),
                              ]),
                              _c('div', { staticClass: 'col-12 col-md-9' }, [
                                _c('p', { staticClass: 'challenge-description mb-0' }, [
                                  _vm._v(
                                    ' Entertainment shapes guest satisfaction and brand perception.',
                                  ),
                                  _c('br'),
                                  _c('br'),
                                  _vm._v(
                                    ' Poor shows lead to negative reviews, reduced visibility, and missed marketing opportunities like social media buzz. ',
                                  ),
                                ]),
                              ]),
                            ]),
                          ],
                        ),
                      ]),
                      _c('div', { staticClass: 'col-12 col-md-4 mb-4' }, [
                        _c(
                          'div',
                          {
                            staticClass:
                              'challenge-card d-flex flex-column align-items-start text-left pb-5 pb-md-0',
                          },
                          [
                            _c('div', { staticClass: 'row' }, [
                              _c('div', { staticClass: 'col-8 d-flex align-items-center' }, [
                                _c('img', {
                                  staticClass: 'challenge-icon mb-2',
                                  attrs: {
                                    loading: 'lazy',
                                    src: 'https://cdn.builder.io/api/v1/image/assets/TEMP/60ed6e56ef5ff4c1d9a122ddb5cd40a9e1c6a6eba0dd13988b48832ec54b304d?placeholderIfAbsent=true&apiKey=4470706791e7431fbb6c8cda4bdffef0',
                                    alt: 'Competition Icon',
                                  },
                                }),
                              ]),
                              _c('div', { staticClass: 'col-12 col-md-7' }, [
                                _c(
                                  'h3',
                                  { staticClass: 'challenge-title mb-2 font-weight-normal' },
                                  [_vm._v('Losing to Competitors')],
                                ),
                              ]),
                              _c('div', { staticClass: 'col-12 col-md-9' }, [
                                _c('p', { staticClass: 'challenge-description mb-0' }, [
                                  _vm._v(' Guests seek exciting experiences.'),
                                  _c('br'),
                                  _c('br'),
                                  _vm._v(
                                    " Without standout entertainment, they'll choose competitors who deliver, leaving your business struggling to keep up. ",
                                  ),
                                ]),
                              ]),
                            ]),
                          ],
                        ),
                      ]),
                      _c('div', { staticClass: 'col-12 col-md-4 mb-4' }, [
                        _c(
                          'div',
                          {
                            staticClass:
                              'challenge-card d-flex flex-column align-items-start text-left pb-5 pb-md-0',
                          },
                          [
                            _c('div', { staticClass: 'row' }, [
                              _c('div', { staticClass: 'col-8 d-flex align-items-center' }, [
                                _c('img', {
                                  staticClass: 'challenge-icon mb-2',
                                  attrs: {
                                    loading: 'lazy',
                                    src: '/assets/icon/showup_icon_loyalty.svg',
                                    alt: 'Loyalty Icon',
                                  },
                                }),
                              ]),
                              _c('div', { staticClass: 'col-12 col-md-9' }, [
                                _c(
                                  'h3',
                                  { staticClass: 'challenge-title mb-2 font-weight-normal' },
                                  [_vm._v(' Reduced Loyalty and Repeat Visits ')],
                                ),
                              ]),
                              _c('div', { staticClass: 'col-12 col-md-9' }, [
                                _c('p', { staticClass: 'challenge-description mb-0' }, [
                                  _vm._v(
                                    ' Engaging entertainment creates lasting memories and encourages loyalty.',
                                  ),
                                  _c('br'),
                                  _c('br'),
                                  _vm._v(
                                    ' Without it, guests are less likely to return, impacting long-term success. ',
                                  ),
                                ]),
                              ]),
                            ]),
                          ],
                        ),
                      ]),
                    ]),
                  ]),
                ],
                1,
              ),
              _c(
                'section',
                {
                  staticClass:
                    'revenue-impact d-flex flex-column flex-lg-row align-items-center justify-content-center gap-4 p-5 my-5',
                  staticStyle: { 'background-color': '#191919' },
                },
                [
                  _c(
                    'b-row',
                    [
                      _vm.display !== 'xs' ? _c('b-col', { attrs: { cols: '1' } }) : _vm._e(),
                      _c(
                        'b-col',
                        {
                          staticClass:
                            'justify-content-md-center justify-content-start pb-md-0 mb-5 align-content-center d-flex',
                          attrs: { md: '3', cols: '12' },
                        },
                        [
                          _c('img', {
                            staticClass: 'revenue-image',
                            attrs: {
                              loading: 'lazy',
                              src: 'https://cdn.builder.io/api/v1/image/assets/TEMP/347c32c450c403e3f52baef8472a0f6b3eba1bf4de143846656cbf02ff8ff679?placeholderIfAbsent=true&apiKey=4470706791e7431fbb6c8cda4bdffef0',
                              alt: 'Revenue Impact Illustration',
                            },
                          }),
                        ],
                      ),
                      _vm.display !== 'xs' ? _c('b-col', { attrs: { cols: '1' } }) : _vm._e(),
                      _c(
                        'b-col',
                        {
                          staticClass: 'revenue-content text-start',
                          attrs: { md: '6', cols: '12' },
                        },
                        [
                          _c('h1', { staticClass: 'revenue-title display-5 fw-medium' }, [
                            _vm._v(' And This All Means... Decreased Revenue! '),
                          ]),
                          _c('p', { staticClass: 'revenue-description fs-5 mt-3' }, [
                            _vm._v(
                              ' Failing to provide great entertainment leads to a cascade of negative effects, all culminating in decreased revenue. All these factors directly impact your bottom line, causing a significant drop in revenue. ',
                            ),
                            _c('br'),
                            _c('br'),
                            _vm._v(
                              ' Ensuring you have top-tier entertainment is crucial to keep your business thriving and profitable. And that’s the main reason you should rely on the best entertainment professionals worldwide! ',
                            ),
                          ]),
                        ],
                      ),
                      _c('b-col', { attrs: { cols: '1' } }),
                    ],
                    1,
                  ),
                ],
                1,
              ),
              _c(
                'section',
                { staticClass: 'partner-section' },
                [
                  _c(
                    'b-row',
                    [
                      _c('b-col', { attrs: { md: '7', cols: '12' } }, [
                        _c(
                          'h2',
                          {
                            staticClass: 'display-4 fw-bold',
                            staticStyle: { 'padding-top': '10%' },
                          },
                          [_vm._v(' Partner with'), _c('br'), _vm._v('Show Up Productions! ')],
                        ),
                      ]),
                    ],
                    1,
                  ),
                  _c(
                    'b-row',
                    { staticClass: 'partner-card py-5' },
                    [
                      _vm.display !== 'xs' ? _c('b-col', { attrs: { cols: '6' } }) : _vm._e(),
                      _c(
                        'b-col',
                        {
                          staticClass: 'd-flex flex-row partner-content',
                          attrs: { md: '4', cols: '12' },
                        },
                        [
                          _c('p', { staticClass: 'partner-description text-left' }, [
                            _vm._v(
                              ' With over 30 years of experience, Show Up Productions creates unforgettable entertainment that captivates audiences and elevates brands. Known for our innovation and excellence, we transform ordinary events into extraordinary experiences, driving guest engagement and loyalty. ',
                            ),
                          ]),
                        ],
                      ),
                    ],
                    1,
                  ),
                ],
                1,
              ),
              _c(
                'section',
                { staticClass: 'benefits-section' },
                [
                  _c(
                    'div',
                    { staticClass: 'benefits-header p-5 my-5' },
                    [
                      _c(
                        'b-row',
                        [
                          _c('b-col', { attrs: { md: '6', cols: '12' } }, [
                            _c('h1', { staticClass: 'benefits-title display-5 fw-medium' }, [
                              _vm._v(
                                ' Let Us Do The Heavy Lifting While You and Your Guests Enjoy The Best Experience Ever! ',
                              ),
                            ]),
                          ]),
                        ],
                        1,
                      ),
                      _c(
                        'b-row',
                        [
                          _c('b-col', { attrs: { md: '4', cols: '12' } }, [
                            _c('h5', { staticClass: 'benefits-subtitle fs-4 mt-3' }, [
                              _vm._v(
                                ' With our extensive experience, Show Up Productions expertly manages every aspect of your entertainment project, ensuring a seamless and spectacular show. ',
                              ),
                              _c('br'),
                              _c('br'),
                              _vm._v(
                                'You can focus on your core business while we handle the rest! ',
                              ),
                            ]),
                          ]),
                        ],
                        1,
                      ),
                    ],
                    1,
                  ),
                  _c(
                    'b-row',
                    { staticClass: 'benefits-grid g-4 mt-4' },
                    [
                      _c('b-col', { attrs: { cols: '12', md: '4' } }, [
                        _c(
                          'div',
                          { staticClass: 'benefit-card text-start px-3 py-4' },
                          [
                            _c('img', {
                              staticClass: 'benefit-icon mb-3',
                              staticStyle: { width: '100%' },
                              attrs: {
                                loading: 'lazy',
                                src: '/assets/img/landing/partner/showup_img_04.webp',
                                alt: 'Custom Show Design Icon',
                              },
                            }),
                            _c('b-row', { staticClass: 'px-4', attrs: { fluid: '' } }, [
                              _c('h2', { staticClass: 'benefit-title fs-3 fw-bold' }, [
                                _vm._v('Custom Show Design'),
                              ]),
                              _c('p', { staticClass: 'benefit-description fs-6 mt-2' }, [
                                _vm._v(
                                  ' We create unique shows tailored to your audience and brand, ensuring a captivating performance every time. ',
                                ),
                              ]),
                            ]),
                          ],
                          1,
                        ),
                      ]),
                      _c('b-col', { attrs: { cols: '12', md: '4' } }, [
                        _c(
                          'div',
                          { staticClass: 'benefit-card text-start px-3 py-4' },
                          [
                            _c('img', {
                              staticClass: 'benefit-icon mb-3',
                              staticStyle: { width: '100%' },
                              attrs: {
                                loading: 'lazy',
                                src: '/assets/img/landing/partner/showup_img_05.webp',
                                alt: 'Talent Management Icon',
                              },
                            }),
                            _c('b-row', { staticClass: 'px-4', attrs: { fluid: '' } }, [
                              _c('h2', { staticClass: 'benefit-title fs-3 fw-bold' }, [
                                _vm._v('Talent Management'),
                              ]),
                              _c('p', { staticClass: 'benefit-description fs-6 mt-2' }, [
                                _vm._v(
                                  ' From recruiting to training, we handle all aspects of artist management, bringing together top-tier talent for your shows. ',
                                ),
                              ]),
                            ]),
                          ],
                          1,
                        ),
                      ]),
                      _c('b-col', { attrs: { cols: '12', md: '4' } }, [
                        _c(
                          'div',
                          { staticClass: 'benefit-card text-start px-3 py-4' },
                          [
                            _c('img', {
                              staticClass: 'benefit-icon mb-3',
                              staticStyle: { width: '100%' },
                              attrs: {
                                loading: 'lazy',
                                src: '/assets/img/landing/partner/showup_img_06.webp',
                                alt: 'Logistics Icon',
                              },
                            }),
                            _c('b-row', { staticClass: 'px-4', attrs: { fluid: '' } }, [
                              _c('h2', { staticClass: 'benefit-title fs-3 fw-bold' }, [
                                _vm._v('Logistics'),
                              ]),
                              _c('p', { staticClass: 'benefit-description fs-6 mt-2' }, [
                                _vm._v(
                                  ' Our team coordinates all logistics, including transportation, setup, and teardown, ensuring a smooth operation without any disruptions. ',
                                ),
                              ]),
                            ]),
                          ],
                          1,
                        ),
                      ]),
                      _c('b-col', { attrs: { cols: '12', md: '4' } }, [
                        _c(
                          'div',
                          { staticClass: 'benefit-card text-start px-3 py-4' },
                          [
                            _c('img', {
                              staticClass: 'benefit-icon mb-3',
                              staticStyle: { width: '100%' },
                              attrs: {
                                loading: 'lazy',
                                src: '/assets/img/landing/partner/showup_img_07.webp',
                                alt: 'Production Management Icon',
                              },
                            }),
                            _c('b-row', { staticClass: 'px-4', attrs: { fluid: '' } }, [
                              _c('h2', { staticClass: 'benefit-title fs-3 fw-bold' }, [
                                _vm._v('Production Management'),
                              ]),
                              _c('p', { staticClass: 'benefit-description fs-6 mt-2' }, [
                                _vm._v(
                                  ' We oversee every detail of the production, from lighting and sound to set and costume design, guaranteeing a high-quality show. ',
                                ),
                              ]),
                            ]),
                          ],
                          1,
                        ),
                      ]),
                      _c('b-col', { attrs: { cols: '12', md: '4' } }, [
                        _c(
                          'div',
                          { staticClass: 'benefit-card text-start px-3 py-4' },
                          [
                            _c('img', {
                              staticClass: 'benefit-icon mb-3',
                              staticStyle: { width: '100%' },
                              attrs: {
                                loading: 'lazy',
                                src: '/assets/img/landing/partner/showup_img_08.webp',
                                alt: 'Paperwork and Compliance Icon',
                              },
                            }),
                            _c('b-row', { staticClass: 'px-4', attrs: { fluid: '' } }, [
                              _c('h2', { staticClass: 'benefit-title fs-3 fw-bold' }, [
                                _vm._v('Paperwork and Compliance'),
                              ]),
                              _c('p', { staticClass: 'benefit-description fs-6 mt-2' }, [
                                _vm._v(
                                  ' We take care of permits and legal requirements and ensure all necessary paperwork is completed accurately and on time. ',
                                ),
                              ]),
                            ]),
                          ],
                          1,
                        ),
                      ]),
                      _c('b-col', { attrs: { cols: '12', md: '4' } }, [
                        _c(
                          'div',
                          { staticClass: 'benefit-card text-start px-3 py-4' },
                          [
                            _c('img', {
                              staticClass: 'benefit-icon mb-3',
                              staticStyle: { width: '100%' },
                              attrs: {
                                loading: 'lazy',
                                src: '/assets/img/landing/partner/showup_img_09.webp',
                                alt: 'Artistic Direction Icon',
                              },
                            }),
                            _c('b-row', { staticClass: 'px-4', attrs: { fluid: '' } }, [
                              _c('h2', { staticClass: 'benefit-title fs-3 fw-bold' }, [
                                _vm._v('Artistic Direction'),
                              ]),
                              _c('p', { staticClass: 'benefit-description fs-6 mt-2' }, [
                                _vm._v(
                                  ' Our experts provide creative guidance, ensuring every element of the show aligns perfectly with your vision and enhances the overall experience. ',
                                ),
                              ]),
                            ]),
                          ],
                          1,
                        ),
                      ]),
                    ],
                    1,
                  ),
                  _c(
                    'b-col',
                    { staticClass: 'text-center', attrs: { fluid: '' } },
                    [
                      _c(
                        'b-button',
                        {
                          staticClass: 'cta-button fw-medium px-4 py-2 my-3',
                          attrs: { variant: 'light' },
                          on: { click: _vm.goToForm },
                        },
                        [_vm._v(' Book A Free Call Today! ')],
                      ),
                    ],
                    1,
                  ),
                ],
                1,
              ),
              _c(
                'section',
                { staticClass: 'team-section text-center my-5' },
                [
                  _c(
                    'b-col',
                    {
                      staticClass: 'team-header mx-auto text-left',
                      staticStyle: { 'padding-top': '5%' },
                      attrs: { fluid: '' },
                    },
                    [
                      _c('h1', { staticClass: 'team-title display-5 fw-medium' }, [
                        _vm._v('Already Have An'),
                        _c('br'),
                        _vm._v('In-House Team?'),
                      ]),
                      _c('h2', { staticClass: 'team-subtitle fs-3 mt-3' }, [
                        _vm._v('Let Us Enhance Your Efforts!'),
                      ]),
                      _c('hr', { staticClass: 'section-divider mx-auto my-4' }),
                    ],
                  ),
                  _c('b-col', { attrs: { md: '4', cols: '12' } }, [
                    _c('p', { staticClass: 'team-description fs-4 text-left' }, [
                      _vm._v(
                        " Let us join forces with your team, seamlessly integrating into their process to support one or multiple aspects of your production. While your talent focuses on delivering outstanding performances, we'll handle the behind-the-scenes to ensure flawless execution and exceptional results! ",
                      ),
                    ]),
                  ]),
                  _c('img', {
                    staticClass: 'team-image img-fluid mt-5',
                    staticStyle: { 'border-radius': '28px' },
                    attrs: {
                      loading: 'lazy',
                      src: 'https://cdn.builder.io/api/v1/image/assets/TEMP/73f5261d543438bbbfaab81ab6432d5a8a1790452cac0bc409a7ed3f110c4673?placeholderIfAbsent=true&apiKey=4470706791e7431fbb6c8cda4bdffef0',
                      alt: 'Team Collaboration Illustration',
                    },
                  }),
                  _c('h2', { staticClass: 'final-cta display-5 fw-medium' }, [
                    _vm._v(
                      ' Book your free consultation with us and discover another new level of entertainment and capitalization! ',
                    ),
                  ]),
                  _c(
                    'div',
                    {
                      staticClass:
                        'final-cta-container d-flex flex-column flex-md-row align-items-center justify-content-center gap-3 mt-5',
                    },
                    [
                      _c(
                        'b-button',
                        {
                          staticClass: 'cta-button fw-medium px-4 py-2 mx-5',
                          attrs: { variant: 'light' },
                          on: { click: _vm.goToForm },
                        },
                        [_vm._v(' Book A Free Call Today! ')],
                      ),
                      _c('div', {
                        staticClass: 'cta-divider d-none d-md-block',
                        staticStyle: {
                          width: '1px',
                          height: '77px',
                          'background-color': '#c6c6c6',
                        },
                      }),
                      _c(
                        'p',
                        {
                          staticClass:
                            'cta-text fs-6 text-center text-md-left mb-0 ml-0 ml-md-5 mt-2 mt-md-0',
                          staticStyle: { 'max-width': '320px' },
                        },
                        [
                          _vm._v(
                            ' Attract new guests, retain your existing ones, enhance your reputation, and drive higher yearly revenue! ',
                          ),
                        ],
                      ),
                    ],
                    1,
                  ),
                ],
                1,
              ),
            ],
            1,
          ),
          _c('footer-row', { staticClass: 'footer' }),
        ],
        1,
      ),
    ],
    1,
  );
};
var staticRenderFns = [];

export default Vue.extend({ render, staticRenderFns });
